import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const shouldIgnoreRuntimeFetchError = (message = '', stack = '') => {
    return message.includes('Failed to fetch') && stack.includes('postUserData');
};

window.addEventListener('error', (event) => {
    const message = event?.error?.message || event?.message || '';
    const stack = event?.error?.stack || '';

    if (shouldIgnoreRuntimeFetchError(message, stack)) {
        event.preventDefault();
    }
});

window.addEventListener('unhandledrejection', (event) => {
    const message = event?.reason?.message || '';
    const stack = event?.reason?.stack || '';

    if (shouldIgnoreRuntimeFetchError(message, stack)) {
        event.preventDefault();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
